import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "container-fluid" }
const _hoisted_2 = { class: "user-profile" }
const _hoisted_3 = { class: "row" }

import { ref, defineAsyncComponent } from 'vue'

export default /*@__PURE__*/_defineComponent({
  __name: 'indexAvatars',
  setup(__props) {

const AvatarSize = defineAsyncComponent(() => import("@/components/theme/uikits/avatar/AvatarSize.vue"))
const AvatarStatus = defineAsyncComponent(() => import("@/components/theme/uikits/avatar/AvatarStatus.vue"))
const AvatarShapes = defineAsyncComponent(() => import("@/components/theme/uikits/avatar/AvatarShapes.vue"))
const AvatarRatio = defineAsyncComponent(() => import("@/components/theme/uikits/avatar/AvatarRatio.vue"))
const AvatarGrouping = defineAsyncComponent(() => import("@/components/theme/uikits/avatar/AvatarGrouping.vue"))

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_unref(AvatarSize)),
        _createVNode(_unref(AvatarStatus)),
        _createVNode(_unref(AvatarShapes)),
        _createVNode(_unref(AvatarRatio)),
        _createVNode(_unref(AvatarGrouping))
      ])
    ])
  ]))
}
}

})